module.exports = __webpack_public_path__ + "img/package.a57fdf70.png";